/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_FixturesInputs */

const th_player_fixtures = /** @type {(inputs: Player_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โปรแกรมแข่งขันของทีม`)
};

const en_player_fixtures = /** @type {(inputs: Player_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Their squad's fixtures`)
};

const ja_player_fixtures = /** @type {(inputs: Player_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所属チームの日程`)
};

const zh_player_fixtures = /** @type {(inputs: Player_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`他所在球队的比赛`)
};

const es_player_fixtures = /** @type {(inputs: Player_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partidos de su equipo`)
};

const pt_player_fixtures = /** @type {(inputs: Player_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogos do time dele`)
};

const id_player_fixtures = /** @type {(inputs: Player_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pertandingan timnya`)
};

const fr_player_fixtures = /** @type {(inputs: Player_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les matchs de son équipe`)
};

const tl_player_fixtures = /** @type {(inputs: Player_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga laro ng team niya`)
};

const vi_player_fixtures = /** @type {(inputs: Player_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Các trận của đội cậu ấy`)
};

const ko_player_fixtures = /** @type {(inputs: Player_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`소속 팀의 경기`)
};

const de_player_fixtures = /** @type {(inputs: Player_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Spiele seines Teams`)
};

const ru_player_fixtures = /** @type {(inputs: Player_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Матчи его команды`)
};

const tr_player_fixtures = /** @type {(inputs: Player_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takımının maçları`)
};

const it_player_fixtures = /** @type {(inputs: Player_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le partite della sua squadra`)
};

const pl_player_fixtures = /** @type {(inputs: Player_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mecze jego drużyny`)
};

const uk_player_fixtures = /** @type {(inputs: Player_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Матчі його команди`)
};

const hi_player_fixtures = /** @type {(inputs: Player_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उनकी टीम के मैच`)
};

const ar_player_fixtures = /** @type {(inputs: Player_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مباريات فريقه`)
};

const ms_player_fixtures = /** @type {(inputs: Player_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perlawanan pasukannya`)
};

const bn_player_fixtures = /** @type {(inputs: Player_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`তাঁর দলের খেলা`)
};

const zh_tw2_player_fixtures = /** @type {(inputs: Player_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`他所屬球隊的比賽`)
};

const zh_hk2_player_fixtures = /** @type {(inputs: Player_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`他所屬球隊的比賽`)
};

const ur_player_fixtures = /** @type {(inputs: Player_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ان کی ٹیم کے میچ`)
};

const fa_player_fixtures = /** @type {(inputs: Player_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بازی‌های تیمش`)
};

const sw_player_fixtures = /** @type {(inputs: Player_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Michezo ya timu yake`)
};

const nl_player_fixtures = /** @type {(inputs: Player_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De wedstrijden van zijn team`)
};

/**
* | output |
* | --- |
* | "Their squad's fixtures" |
*
* @param {Player_FixturesInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const player_fixtures = /** @type {((inputs?: Player_FixturesInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_FixturesInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_player_fixtures(inputs)
	if (locale === "ja") return ja_player_fixtures(inputs)
	if (locale === "zh") return zh_player_fixtures(inputs)
	if (locale === "es") return es_player_fixtures(inputs)
	if (locale === "pt") return pt_player_fixtures(inputs)
	if (locale === "id") return id_player_fixtures(inputs)
	if (locale === "fr") return fr_player_fixtures(inputs)
	if (locale === "tl") return tl_player_fixtures(inputs)
	if (locale === "vi") return vi_player_fixtures(inputs)
	if (locale === "ko") return ko_player_fixtures(inputs)
	if (locale === "de") return de_player_fixtures(inputs)
	if (locale === "ru") return ru_player_fixtures(inputs)
	if (locale === "tr") return tr_player_fixtures(inputs)
	if (locale === "it") return it_player_fixtures(inputs)
	if (locale === "pl") return pl_player_fixtures(inputs)
	if (locale === "uk") return uk_player_fixtures(inputs)
	if (locale === "hi") return hi_player_fixtures(inputs)
	if (locale === "ar") return ar_player_fixtures(inputs)
	if (locale === "ms") return ms_player_fixtures(inputs)
	if (locale === "bn") return bn_player_fixtures(inputs)
	if (locale === "zh-TW") return zh_tw2_player_fixtures(inputs)
	if (locale === "zh-HK") return zh_hk2_player_fixtures(inputs)
	if (locale === "ur") return ur_player_fixtures(inputs)
	if (locale === "fa") return fa_player_fixtures(inputs)
	if (locale === "sw") return sw_player_fixtures(inputs)
	if (locale === "nl") return nl_player_fixtures(inputs)
	return en_player_fixtures(inputs)
});